<template>
  <div class="main-basic-info-data">
    <template v-if="!loaded">
      <div class="main-basic-info-data__item" v-for="n in 4" :key="n">
        <div class="main-basic-info-data__text b-empty shine-short"></div>
      </div>
    </template>
    <template v-else>
      <div class="main-basic-info-data__item" v-for="(item, i) in items" :key="i">
        <div class="main-basic-info-data__text">
         {{item.key}} <b>{{ item.value }}</b>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    loaded: {
      type: Boolean,
      default: false
    }
  }
};
</script>